import type * as API from '~/types/api'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

type PropertyData = App.Data.Document.Metadata.PropertyData
export const responseDataTypeName: PropertyData['_type'] = 'property'

/**
 * Source is included incorrectly in the type and name is not actually required and will be derived from the title if not present.
 */
export type CreatePropertyPayload = Omit<
  App.Data.Payloads.Metadata.Properties.CreatePropertyPayload,
  'source' | 'name'
>

export const useFetchDocumentProperty = () => {
  const url = '/v2/metadata/attributes'

  const { get, put, post, deleteRequest } = useFetchWithDefaults()

  const getAll = ({ workspaceId }: WorkspaceIdentifier) =>
    get<API.v2.CollectionResponse<PropertyData>>({
      url,
      workspaceId,
    })

  const update = (
    {
      id,
      payload,
      workspaceId,
    }:
      WorkspaceIdentifier & {
        id: string
        payload: App.Data.Payloads.Metadata.Properties.UpdatePropertyPayload
      },
  ) => put<API.v2.Response<PropertyData>>({
    url: `${url}/${id}`,
    fetchOptions: {
      body: payload,
    },
    workspaceId,
  })

  const create = (
    {
      payload,
      workspaceId,
    }:
      WorkspaceIdentifier & {
        payload: CreatePropertyPayload
      },
  ) => post<API.v2.Response<PropertyData>>({
    url,
    fetchOptions: {
      body: payload,
    },
    workspaceId,
  })

  const drop = ({ workspaceId, id }: WorkspaceIdentifier & { id: string }) =>
    deleteRequest({
      url: `${url}/${id}`,
      workspaceId,
    })

  return {
    getAll,
    update,
    create,
    drop,
  }
}
